import { log } from "console";
import React, { createContext, useContext, useState, ReactNode } from "react";

interface Address {
  zipCode: string | null;
  street: string | null;
  number: string | null;
  complement: string | null;
  district: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
}

interface Phone {
  countryCode: number | null;
  areaCode: number | null;
  number: number | null;
}
interface Signatario {
  cpf: string;
  name: string;
  telefone: string;
  email: string;
  representanteLegal?: boolean;
}

interface FormData {
  type: "cpf" | "cnpj";

  fullName: string;
  nome: string;
  telefone: string;
  cnpj: string;
  document: string;
  productId: string;
  email: string;
  photo: string;
  sessionId: string;
  responseLiveness: string;
  representativeCpf: string;
  companyname: string;
  phone: string;
  address: Address;

  razaoSocial?: string;
  signatories?: Signatario[];
}

interface FormContextProps {
  formData: FormData;
  updateForm: (name: string, value: string, fieldPath: string | null) => void;
  resetForm: () => void;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

export const initialFormData: FormData = {
  signatories: [{ cpf: "", name: "", telefone: "", email: "" }],
  type: "cpf",
  fullName: "",
  nome: "",
  telefone: "",
  cnpj: "",
  email: "",
  document: "",
  phone: "",
  address: {
    zipCode: "",
    street: "",
    number: "",
    complement: "",
    district: "",
    city: "",
    state: "",
    country: "",
  },
  productId: "",
  responseLiveness: "",
  photo: "",
  sessionId: "",
  representativeCpf: "",
  companyname: "",
  razaoSocial: "",
};

// Criando o Contexto
const FormContext = createContext<FormContextProps | undefined>(undefined);

// Criando o Provider
export const FormProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [formData, setFormData] = useState<FormData>(initialFormData);

  // Função para atualizar o formulário
  const updateForm = (
    name: string,
    value: string,
    fieldPath: string | null
  ) => {
    if (fieldPath) {
      setFormData((prev) => ({
        ...prev,
        [fieldPath]:
          fieldPath == "address"
            ? {
                ...prev.address,
                [name]: value,
              }
            : {},
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Função para resetar o formulário
  const resetForm = () => {
    setFormData({
      type: "cpf",
      fullName: "",
      nome: "",
      telefone: "",
      cnpj: "",
      email: "",
      document: "",
      phone: "",
      address: {
        zipCode: "",
        street: "",
        number: "",
        complement: "",
        district: "",
        city: "",
        state: "",
        country: "",
      },
      productId: "",
      responseLiveness: "",
      photo: "",
      sessionId: "",
      representativeCpf: "",
      companyname: "",

      razaoSocial: "",
      signatories: [{ cpf: "", name: "", telefone: "", email: "" }],
    });
  };

  return (
    <FormContext.Provider
      value={{ formData, updateForm, resetForm, setFormData }}
    >
      {children}
    </FormContext.Provider>
  );
};



// Hook personalizado para usar o contexto
export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};
